import { PICKUP_STORE_CONST, type PickupStoreConfig } from './PickupStoreOption.d';
import { PickupStore } from './PickupStoreOption.style';

const PickupStoreOption = ({ title }: PickupStoreConfig) => (
  <PickupStore.Component data-testid={PICKUP_STORE_CONST.TEST_ID}>
    <PickupStore.Title>{title.toLowerCase()}</PickupStore.Title>
  </PickupStore.Component>
);

export default PickupStoreOption;
